<template>
    <div class="home-wrapper" v-if="activityData" :style="{'background-color': activityData.bgColor || '#fff'}">
        <div class="apply-top">
            <div class="banner">
                <img :src="activityData.image" alt="">
            </div>
            <h3 class="title">{{activityData.title}}</h3>
            <div class="desc" v-html="activityData.desc"></div>
            <div class="apply-info" v-if="activityData.time || activityData.address">
                <p class="time"><span class="icon iconfont">&#xe784;</span><b>{{activityData.time}}</b></p>
                <p class="adress"><span class="icon iconfont">&#xe790;</span><b>{{activityData.address}}</b></p>
            </div>
        </div>
        <div class="apply-wrap">
            <h4 class="apply-title">报名信息</h4>
            <div class="apply-item" v-for="(item, index) in activityData.field" :key="index">
                <label for=""><span v-if="item.isMust">*</span>{{item.name}}</label>
                <div class="apply-field">
                    <!-- 文本框 -->
                    <input class="apply-field-type" v-if="item.type != 'textarea' && item.type != 'image' && item.type != 'video'" type="text" :name="item.field" :data-required="item.isMust">                   
                    <!-- 文本域 -->
                    <textarea class="apply-field-type apply-field-textarea" v-if="item.type == 'textarea'" :name="item.field" :data-required="item.isMust"></textarea>
                    <!-- 下拉框 -->
                    <select class="apply-field-type apply-field-select" v-if="item.type == 'select'" :name="item.field" :data-required="item.isMust">
                        <option v-for="(opt, optIdx) in item.options" :value="opt.val" :key="optIdx">{{opt.text}}</option>
                    </select>
                    <span class="icon iconfont" v-if="item.type == 'select'">&#xe8ec;</span> 
                    <!-- 上传 -->
                    <div class="apply-upload" v-if="item.type == 'image' || item.type == 'video'">
                        <upload-component :type="item.type" :field="item.field" :required="item.isMust" :maxlen="item.maxLen || 1" @dialogDataEvent="setDialogData"></upload-component>
                    </div>                 
                </div>
            </div>
            <button class="apply-submit-btn" @click="submit" :disabled="btnDisabled">立即提交</button>
        </div>
        <dialog-component @loginEvent="getUserInfon"></dialog-component>
    </div>
</template>

<script>

import COVER from '@/utils/COVER'
import UploadComponent from '@/components/Upload'
import DialogComponent from '@/components/Dialog'
import COVERAPP from '@/utils/COVERAPP'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'Home',
    data() {
        return {
            btnDisabled: false,
            formData: {}
        }
    },
    props: ['activityData', 'baseData'],
    computed: {
		...mapState(['dialogData', 'userInfo']),
	},
    components: {
        UploadComponent,
        DialogComponent
    },
    created() {
        this.aid = this.$route.query.id || ''
    },
    mounted() {
        if(COVERAPP.Attribute.isApp() || !this.activityData.isAppShow) {
            this.getUserInfon() 
        }
        this.share();
        setTimeout(()=> {
            this.setPageLoadingAsync(false);
        }, 500);
    },
    methods: {
        ...mapActions([
            'setPageLoadingAsync',
            'setDialogDataAsync',
            'setUserInfoAsync'
		]),
        getUserInfon() {
            this.setUserInfoAsync();    
        },
        //分享
        share() {
            let data = this.baseData.share;
            let shareData = {
                title: data.title,
                desc: data.desc,
                imgUrl: data.imgUrl,
                link: data.link || window.location.href
            }
            COVER.share(shareData)
        },
        submit() {
            if(!this.userInfo.token) {
                this.setDialogDataAsync({
                    message: '参与活动，需登录!',
                    btns: [
                        {
                            text: '去登录',
                            className: 'login-btn'
                        },
                        {
                            text: '取消',
                            className: 'close-btn'
                        }
                    ]
                })
                return;
            }
            if(this.btnDisabled) return;
            this.btnDisabled = true;
            if(this.validateForm()) { 
                this.setDialogDataAsync(null);            
                COVER.$post('/apply', {
                    info: this.formData,
                    token: this.userInfo.token + '',
                    userinfo: this.userInfo,
                    aid: this.aid
                }).then((ret) => {
                    this.btnDisabled = false
                    if(ret.errno == 0){
                        this.setDialogDataAsync({
                            message: '成功参与!',
                            btns: [
                                {
                                    text: '确认',
                                    className: 'link-btn',
                                    link: `/?id=${this.aid}`
                                }
                            ]
                        })
                    }else{
                        let msg = '';
                        if(ret.errno == 1004){
                            msg = '重复提交';
                        }else if(ret.errno == 1001){
                            msg = '尚未开始';
                        }else if(ret.errno == 1002){
                            msg = '已结束';
                        }else{
                            msg = '参与失败,'+ ret.errmsg;
                        }
                        this.setDialogDataAsync({
                            message: msg,
                            btns: [
                                {
                                    text: '确认'
                                }
                            ]
                        })
                        return false;
                    }
                }).catch(() => {
                    this.setDialogDataAsync(null);
                });
            } else {
                this.btnDisabled = false
            }
        },
        validateForm() {
            let inputs = document.querySelectorAll('input, select, textarea')            
            let filterInputs = []
            let validateResult = true
            inputs.forEach((v, i) => {
                if(v.name) {
                    filterInputs.push(v)
                }
            })
            let len = filterInputs.length
            for(let i = 0; i < len; i++) {
                let curfield = this.activityData.field[i]
                let curVal = filterInputs[i].value
                let message = ''
                if(curfield.isMust && curVal == '') {                    
                    if(curfield.type == 'select') {
                        message = `请选择${curfield.name}`
                    } else if (curfield.type == 'image' || curfield.type == 'video') {
                        message = `请上传${curfield.name}`
                    } else {
                        message = `请填写${curfield.name}`
                    }
                    this.setDialogDataAsync({
                        message,
                        btns: [
                            {
                                text: '确认'
                            }
                        ]
                    })
                    validateResult = false
                    break;
                } else if (curVal != '' && curfield.regexp && !(eval(curfield.regexp)).test(curVal)) {
                    this.setDialogDataAsync({
                        message: `${curfield.name}格式填写错误`,
                        btns: [
                            {
                                text: '确认'
                            }
                        ]
                    })
                    validateResult = false
                    break;
                } else {
                    this.formData[curfield.field] = curVal
                }
            }
            return validateResult
        },
        setDialogData(msg) {
            this.setDialogDataAsync({
                message: msg,
                btns: [
                    {
                        text: '确认'
                    }
                ]
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .home-wrapper {
        overflow: hidden;
        min-height: 100vh;
    }
    .apply-top {
        margin-bottom: 0.2rem;
        .title {
            text-align: center;
            font-size: .5rem;
            padding: .2rem .3rem;
            line-height: 1.5em;
            font-weight: normal;
        }
        .desc {
            font-size: .4rem;
            padding: 0 0.3rem;
            line-height: 1.3;
        }
        .apply-info {                       
            padding: .2rem .3rem;
            p {
                display: flex;
                align-items: center;
                padding: .05rem 0;
                span {
                    font-size: 0.4rem;
                    margin-right: .2rem;
                    color: #444;
                }
                b {
                    font-size: .28rem;
                    font-weight: normal;
                }
            }
        }
    }
    .apply-wrap {
        padding: .2rem .3rem .5rem .3rem;
    }
    .apply-title {
        color: #000;
        font-size: .4rem;
        border-bottom: 1px solid #999;
        line-height: 2;
        font-weight: normal;
    }
    .apply-item {
        margin-top: .4rem;
        label {
            font-size: .4rem;
            span {
                color: red;
            }
        }
    }
    .apply-field {
        margin-top: 0.2rem;
        position: relative;
        .apply-field-type {
            width: 100%;
            appearance: none;
            font-size: .4rem;
            line-height: 1.3;
            padding: .2rem;
            border: 1px solid #d9d9d9;
            box-sizing: border-box;
            border-radius: .05rem;
            outline: none;
            &.apply-field-textarea {
                height: 2rem;
            }
            &.apply-field-select {
                padding-right: 1rem;
            }
        } 
        span {
            position: absolute;
            font-size: 0.4rem;
            right: 0.3rem;
            top: 0.28rem;
            color: #666;
        }       
    }
    .apply-submit-btn {
        font-size: .4rem;
        background: #7070ef;
        color: #fff;
        width: 100%;
        letter-spacing: .1rem;
        line-height: 1rem;
        text-align: center;
        margin-top: .7rem;
        box-sizing: border-box;
        appearance: none;
        border: none;
    }
</style>